import { Button, Result } from "antd";
import React from "react";

// Issue #58 由来の再発防止(構造対策)。
// render 例外で React 18 が全ツリーを unmount して白画面になるのを防ぐため、
// 例外をこの境界内で捕捉しフォールバック UI を表示する。
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error("[ErrorBoundary] Unhandled render error:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<Result
					status="error"
					title="Something went wrong"
					subTitle="Please reload the page to continue."
					extra={
						<Button type="primary" onClick={() => window.location.reload()}>
							Reload page
						</Button>
					}
				/>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
